export default __webpack_public_path__ + "static/media/lb-mg.64c3f92b.webp";